<template>
  <div class="c-profile-cards">
    <Modal v-if="isModal" @onHide="onHide" :onAction="deleteAccount" />
    <ul class="c-profile-cards__nav">
      <li
        class="c-profile-cards__nav__item"
        v-for="(item, index) in nav"
        @click="onNavClick(index)"
        :key="index"
        :style="{
          color: currentTab === index ? campaign.css_settings.primary : '',
          fontWeight: currentTab === index ? 'bold' : ''
        }"
      >
        {{ item }}
      </li>
      <li v-if="!isMobile" class="c-profile-cards__nav__item--support">
        <a :href="'mailto:' + $store.state.campaign.support_email">
          <button class="btn c-profile-cards__nav__btn">
            <span class="c-profile-cards__btn__icon" v-html="supportIcon"></span
            ><span class="c-profile-cards__nav__text">{{
              $t("Info e supporto")
            }}</span>
          </button>
        </a>
      </li>
    </ul>
    <div
      style="margin-bottom: 50px"
      class="swiper-pagination"
      slot="pagination"
    ></div>
    <swiper ref="swiper" :options="swiperOption">
      <swiper-slide class="no-swipe">
        <PersonalTab />
      </swiper-slide>
      <swiper-slide class="no-swipe">
        <ContactsTab />
      </swiper-slide>
      <swiper-slide class="no-swipe">
        <PrivacyTab v-model="isModal" />
      </swiper-slide>
    </swiper>
    <a :href="'mailto:' + $store.state.campaign.support_email" v-if="isMobile">
      <button
        class="btn c-profile-cards__nav__btn c-profile-cards__nav__btn--mobile"
      >
        <span class="icon" v-html="supportIcon"></span
        ><span class="c-profile-cards__nav__text">{{
          $t("Per qualsiasi problema o segnalazioni scrivici")
        }}</span>
        <i class="fas fa-chevron-right"></i>
      </button>
    </a>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";

import PersonalTab from "./PersonalTab";
import ContactsTab from "./ContactsTab";
import PrivacyTab from "./PrivacyTab";
import Modal from "./Modal";

import { mapGetters } from "vuex";
import { GlobalService } from "@/common/services/api.service.js";
import { Actions, Mutations } from "@/store/global/global.types.js";

import supportIcon from "@/assets/svg/new/support.svg";

export default {
  name: "ProfileCards",
  components: {
    swiper,
    swiperSlide,
    PersonalTab,
    ContactsTab,
    PrivacyTab,
    Modal
  },
  computed: {
    ...mapGetters(["isMobile", "isTablet", "isDesktop", "getUser", "campaign"]),
    swiper() {
      return this.$refs.swiper.swiper;
    }
  },
  created() {
    setTimeout(() => {
      this.currentTab = parseInt(this.$route.query.tab);
      this.swiper.slideTo(this.currentTab, 500);
    });
  },
  data() {
    return {
      swiperOption: {
        spaceBetween: 20,
        speed: 500,
        noSwiping: true,
        noSwipingClass: "no-swipe"
      },
      nav: [
        this.$i18n.t("Dettagli personali"),
        this.$i18n.t("Contatti"),
        this.$i18n.t("Consensi")
      ],
      supportIcon,
      isModal: false,
      currentTab: 0
    };
  },
  methods: {
    onNavClick(index) {
      this.currentTab = index;
      this.swiper.slideTo(index, 500);
    },
    onHide() {
      this.isModal = false;
    },
    async deleteAccount() {
      this.$store.commit(Mutations.SHOW_SPINNER);
      try {
        await GlobalService.deleteAccount();
        await this.$store.dispatch(Actions.GET_USER_PROFILE);
      } catch (e) {
        this.$store.commit("pushMessage", {
          type: "error",
          title: "Error",
          text: "An error occurred"
        });
      }
      this.isModal = false;
      this.$store.commit(Mutations.HIDE_SPINNER);
    }
  }
};
</script>

<style lang="scss">
.overflow-hidden {
  overflow: hidden;
}

.c-profile-cards {
  position: relative;
  padding-top: 15px;
  @media (min-width: 767px) {
    padding-bottom: 50px;
  }
}

.c-profile-cards__card.tile {
  min-height: 525px;
  @media (min-width: 767px) {
    padding: 60px 107px;
  }
}

.c-profile-cards__nav {
  margin: 0;
  color: #000;
  display: flex;
  overflow-y: auto;
  white-space: nowrap;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 10+ */
  &::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }

  align-items: center;
  margin-bottom: 15px;

  @media (min-width: 767px) {
    margin-bottom: 20px;
    padding: 30px;
    background-color: #fff;
    border-radius: 5px;
  }
}

.c-profile-cards__nav__item {
  padding: 5px;
  margin: 0 15px;
  cursor: pointer;

  &:first-of-type {
    padding-left: 0;
    margin-left: 0;
  }
}

.c-profile-cards__card__input {
  margin-bottom: 35px;
  @media (min-width: 992px) {
    width: 43%;
  }
}

.c-profile-cards__log-out.btn {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  @media (min-width: 992px) {
    margin-bottom: 0;
    padding-left: 0;
  }
}

.c-profile-cards__log-out__text {
  margin-top: -6px;
  margin-left: 10px;
}

.c-profile-cards__save.btn {
  padding: 10px 50px;
  @media (min-width: 992px) {
    margin-right: 50px;
  }
}

.c-profile-cards__input__icon {
  position: absolute;
  top: 30px;
  right: 10px;
}

.c-profile-cards__social {
  display: flex;
  flex-direction: column;
}

.c-profile-cards__social__title {
  text-align: left;
  margin-bottom: 20px;
  color: #8a8497;
}

.c-profile-cards__social__item {
  display: flex;
  margin-bottom: 30px;
  align-items: center;
}

.c-profile-cards__social__icon {
  width: 35px;
  height: 35px;
  border-radius: 5px;
  background-color: #e5f3ff;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #5877a5;
}

.c-profile-cards__social__name {
  color: #5878a6;
  font-weight: bold;
  margin-left: 20px;
  margin-bottom: 0;
}

.c-profile-cards__privacy {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (min-width: 992px) {
    flex-direction: row;
    justify-content: space-between;
  }
}

.c-profile-cards__privacy__checkbox {
  margin-bottom: 30px;
}

.c-profile-cards__privacy__delete.btn {
  padding-left: 0;
  margin-bottom: 20px;
  @media (min-width: 992px) {
    margin-bottom: 0;
  }
}

.c-profile-cards__inputs {
  width: 100%;
  @media (min-width: 992px) {
    display: flex;
    justify-content: space-between;
  }
}

.c-profile-cards__social-cnt {
  width: 100%;
}

.c-profile-cards__actions {
  display: flex;
  flex-direction: column;
  @media (min-width: 992px) {
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-top: 15px;
  }
}

.c-profile-cards__nav__item--support {
  margin-left: auto;

  a:hover {
    text-decoration: none;
  }
}

.c-profile-cards__nav__btn.btn {
  border-radius: 10px;
  background-color: #ecf3fd;
  color: #5576a4;
  display: flex;
  align-items: center;
}

.c-profile-cards__nav__text {
  margin-left: 16px;
}

.c-profile-cards__nav__btn--mobile.btn {
  width: 100%;
  padding: 26px 16px;
  display: flex;
  align-items: center;
  margin-top: 20px;
  overflow-wrap: break-word;

  .icon {
    display: flex;
    justify-content: center;
    align-items: center;

    svg {
      width: 40px;
      height: 40px;
    }
  }

  .fa-chevron-right {
    font-size: 14px;
    margin-bottom: 5px;
    margin-left: 10px;
  }

  .c-profile-cards__nav__text {
    display: block;
    overflow-wrap: break-word;
    word-break: break-word;
    width: calc(100% - 40px);
    max-width: 100%;
    white-space: break-spaces;

    text-align: left;
  }
}

.btn-wrapper {
  min-width: 140px;
  min-height: 46px;
}

.c-profile-cards__btn__icon {
  display: flex;
  justify-content: center;
  align-items: center;
}

.swiper-container {
  background-color: #fff;
  border-radius: 5px;
}
</style>
